module.exports = __webpack_public_path__ + "img/76d3cbf.jpg";